<template>
  <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
    <v-toolbar dark color="primary" class="fullToolbar">
      <v-toolbar-title class="white--text" style="font-size: 30px; text-align: right;">
        <i class="material-icons icon">settings</i>הגדרות חשבון
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon v-if="$root.device.isMobile" @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
    </v-toolbar>
    <div style="max-width: 500px; width:100%; overflow-y:scroll;">
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          סוג חשבון
        </v-flex>
        <v-flex xs7>
          <b>{{user.Type}}</b>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          שם מלא
        </v-flex>
        <v-flex xs7>
          <input type="text" v-model="user.FullName" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          תעודת זהות
        </v-flex>
        <v-flex xs7>
          <input type="text" v-model="user.Identity" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;" v-show="$root.isCustomer">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          איש קשר
        </v-flex>
        <v-flex xs7>
          <input type="text" v-model="user.ContactPerson" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          טלפון
        </v-flex>
        <v-flex xs7>
          <input type="text" v-model="user.Phone" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          שם משתמש
        </v-flex>
        <v-flex xs7>
          <input type="text" v-model="user.Username" disabled="disabled" style="background-color:#eee; text-align: center;" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          סיסמה
        </v-flex>
        <v-flex xs7>
          <input type="password" v-model="user.Password" style="text-align:center;" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right style="text-align: right; padding-right: 10px;">
          אימות סיסמה
        </v-flex>
        <v-flex xs7>
          <input type="password" v-model="confirmPassword" style="text-align:center;" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding-top: 20px; margin-right: 50px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-layout>
      <v-flex xs12 actions style="padding: 20px 10px 10px 10px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </div>
  </v-card>
</template>

<script>

  import { db } from '../firebase';

  export default {
    name: 'MyAccount',
    data() {
      return {
        error: '',
        //customersList: [],
        //customer: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', Password: '', TotalDiaries: 0, UsedDiaries: 0 },
        user: { '.key': '', FullName: '', Username: '', Identity: '', Type: '', Password: '', Active: false, Approved: false },
        confirmPassword: '',
      }
    },
    //firebase: function () {
    //  var vm = this;
    //  var username = vm.$root.user.Username;
    //  var uid = vm.$root.user.uid;
    //  return {
    //    user: usersRef.orderByChild('Username').equalTo(username)
    //  }
    //},
    created() {
      this.$Log("Vue [MyAccount] is created ...");
    },
    ready() {
      this.$Log("Vue [MyAccount] is ready ...");
    },
    mounted() {
      this.$Log("Vue [MyAccount] is mounted ...");
      var vm = this;

      vm.user = JSON.parse(vm.$localStorage.get('user'));
    },
    updated() {
      this.$Log("Vue [MyAccount] is updated ...");
    },
    computed: {
    },
    watch: {
    },
    methods: {
      save() {
        var vm = this;
        if (vm.isValid()) {
          var item = {
            FullName: vm.user.FullName,
            Username: vm.user.Username,
            Identity: vm.user.Identity,
            Type: vm.user.Type,
            Password: vm.user.Password,
            TotalDiaries: vm.user.TotalDiaries,
            UsedDiaries: vm.user.UsedDiaries,
            MessagesCounter: vm.user.MessagesCounter,
            ContactPerson: vm.user.ContactPerson,
            Active: vm.user.Active,
            Approved: vm.user.Approved
          };

          var usersRef = db.ref('Users/' + vm.user['.key']);
          usersRef.set(item);
          vm.$root.alert.message = "החשבון עודכן בהצלחה";
          vm.$root.alert.isShow = true;
          vm.$localStorage.set('user', JSON.stringify(vm.user));
        }
      },
      cancel() {
        var vm = this;
        vm.user = JSON.parse(vm.$localStorage.get('user'));
      },
      isValid() {
        var vm = this;
        vm.error = "";

        if (vm.user.Username == undefined || vm.user.Username.length == 0) {
          vm.error = "* שם משתמש לא נכון";
          return false;
        }

        if (vm.user.Password == undefined || vm.user.Password.length == 0) {
          vm.error = "* נא הכנס סיסמה";
          return false;
        }

        if (vm.user.Password != vm.confirmPassword) {
          vm.error = "* אימות סיסמה נכשל";
          return false;
        }

        if (vm.user.FullName.length == 0) {
          vm.error = "* נא הכנס שם מלא";
          return false;
        }

        if (vm.user.Identity.length == 0) {
          vm.error = "* נא הכנס תעודת זהות";
          return false;
        }

        return true;
      },
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// MyAccount.vue?6e71b981